import styled from 'styled-components';
import { breakpoints } from 'utils/rwd';

export const ProductSearchWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: stretch;
  gap: 20px;
  padding: 3px;

  @media (max-width: ${breakpoints.sm - 1}px) {
    grid-template-columns: 1fr auto;
  }

  .input-group-prepend {
    span {
      height: 100%;
      width: 30px;

      i {
        margin: 0 auto;
      }
    }
  }
`;

export const DropdownItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  border-bottom: 1px solid #e9ecef;

  p {
    margin: 0;
    font-size: 13px;
  }

  desc {
    font-size: 11px;
  }

  span {
    font-size: 13px;
    color: #be1622;
    font-size: bold;
  }
`;

export const FilterButton = styled.button.attrs({
  className: 'btn btn-white btn-sm',
})`
  white-space: nowrap;
  height: 100%;

  ${({ $active }) =>
    $active &&
    `
    color: #be1622;
    border-color: #be1622;

    &.btn-white:hover,
    &.btn-white:focus,
    &.btn-white:active {
      color: #be1622;
      border-color: #be1622;
    }
  `}
`;

export const ClearButton = styled.button`
  height: 100%;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const WrapperAutocomplete = styled.div`
  display: flex;
  height: 100%;
  @media (max-width: ${breakpoints.sm - 1}px) {
    grid-column: 1 / -1;
  }

  i {
    color: #be1622;
  }
`;
